<div>
    <cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="removedInvoiceDatesList | async" (sortTriggered)="onSort($event)"
        (filterTriggered)="onFilter($event)" (clearFilterAndSortingTriggered)="onClearFilter()"
        [isLoading]="isLoading | async" [filterExpression]="filterExpression | async"
        [dataTotalCount]="totalCount | async">
    </cal-calsiumlist-listing>
    <cal-pagination [paging]="paging | async" (pageChange)="onPaging($event)" [dataTotalCount]="totalCount | async">
    </cal-pagination>
</div>